export enum ReasonForSubmittal {

  SourceSampling = 'Source Sampling',
  CorrelationTesting = 'Correlation Testing',
  VerificationTesting = 'Verification Testing',
  ShadeEvaluation = 'Shade Evaluation'
}
